import { useId } from "react";

import { IconProps } from "@assets/svg/types";
import { useTheme } from "@hooks";

export const Shield = ({ style, size = 19, fill: fillProp }: IconProps) => {
  const { theme } = useTheme();
  const fill = fillProp ?? theme.text.highlight;
  const clipId = useId().replace(/:/g, "");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M9.4974 17.4193C9.4974 17.4193 15.8307 14.2526 15.8307 9.5026V3.96094L9.4974 1.58594L3.16406 3.96094V9.5026C3.16406 14.2526 9.4974 17.4193 9.4974 17.4193Z"
          stroke={fill}
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
